<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";
import {easepick} from '@easepick/core';
import {TimePlugin} from '@easepick/time-plugin';
import moment from 'moment';

export default {
  mixins: [formInput],
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  },
  methods: {
    changeModelValue(value) {
      if (this.form) {
        delete this.form.errors[this.name];
      }
      this.$emit('update:modelValue', value);
    },

    initialiseEasepick() {
      let $input = $(this.$refs.input);
      let datepicker = new easepick.create({
        plugins: [TimePlugin],
        TimePlugin: {
          format: 'HH:mm',
        },
        element: this.$refs.input,
        css: [
          '/css/easepick.css',
        ],
        zIndex: 10,
        format: 'YYYY-MM-DD HH:mm',
        autoApply: false,
        lang: 'nl-NL',
        locale: {
          nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"></path></svg>',
          previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"></path></svg>',
          cancel: 'Annuleren',
          apply: 'Toepassen'
        }
      });

      $input.data('datepicker', datepicker);

      datepicker.on('select', () => {
        this.changeModelValue($input.val());
      });

      this.$watch('modelValue', (value) => {
        datepicker.setTime(moment(value).format('HH:mm:ss'));
        datepicker.setDate(value);
      });

      // Dit is een fix voor de buttons.
      // Easepick heeft namelijk een bug dat als je de tijd veranderd dat de apply button disabled blijft.
      $(datepicker.Calendar.picker.ui.shadowRoot.firstChild).on('change', '.time-plugin-custom-input', (event) => {
        $(event.currentTarget)
            .closest('.container')
            .find('.apply-button')
            .removeAttr('disabled');
      })
    }
  },
  mounted() {
    this.initialiseEasepick();
  }
}
</script>

<template>
  <input
      ref="input"
      :name="name"
      v-bind="$attrs"
      type="datetime-local"
      :id="renderedId"
      :class="{'form-control': true, 'border-danger': hasError}"
      :value="modelValue"
  >

  <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>